export default __webpack_public_path__ + "static/product-feature-assignments-4e0fedc8d59afa3e875e346972dd754c.svg";